import { createApp, watch } from "vue";
import { createYmaps, VueYandexMaps } from "vue-yandex-maps";
import { createI18n, useI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { languages, defaultLocale } from "@/i18n";
import * as Sentry from "@sentry/vue";

import StorageLogger from "@/modules/common/utils/storageLogger";

// Begin // This parameter resolves the conflict of Tailwind CSS styles with naive.
const meta = document.createElement("meta");
meta.name = "naive-ui-style";
document.head.appendChild(meta);
// End

const localeStorageLang = StorageLogger.getItem("locale") || null;
const messages = Object.assign(languages);
const i18n = createI18n({
  legacy: false,
  locale: localeStorageLang || defaultLocale,
  fallbackLocale: "ru",
  messages,
});

const app = createApp(App, {
  setup() {
    const { t } = useI18n();
    return t;
  },
});

app.use(store);

store.dispatch("auth/AUTO_SIGN_IN").then(() => {
  app.use(router);
  app.use(i18n);
  app.mount("#app");
});
